import type { FC, HTMLProps, ReactNode } from "react";

import type { AviaryColors } from "@aviary/types/aviaryColors";
import { profiles } from "@styles";

import * as styles from "./Box.styles";

interface BoxProps extends HTMLProps<HTMLDivElement> {
  /**
   * Allows you to add color to the background
   *
   * @default null
   */
  isColor?: AviaryColors;
  /**
   * Removes gutters made by padding from the Container component. Uses negative margin.
   *
   * @default false
   */
  isGutterless?: boolean;
  /**
   * Allows you to add color to the border
   *
   * @default false
   */
  isBordered?: boolean;
  /**
   * Children to be rendered within the Box
   *
   * @default undefined
   */
  children?: ReactNode;
}

const Box: FC<BoxProps> = ({ isColor, isGutterless, isBordered, children, ...rest }: BoxProps) => {
  const stringToProfile = {
    primary: profiles.primaryProfile,
    dark: profiles.darkProfile,
    danger: profiles.dangerProfile,
    warning: profiles.warningProfile,
    info: profiles.infoProfile,
    purple: profiles.purpleProfile,
    light: profiles.lightProfile,
  };

  const css = [
    styles.box,
    isGutterless && styles.gutterless,
    isColor && styles.boxColors(stringToProfile[isColor]),
    isBordered && isColor && styles.borderColor(stringToProfile[isColor]),
  ];
  return (
    <section css={css} {...rest}>
      {children}
    </section>
  );
};
export type { BoxProps };
export { Box };
